import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Vuelidate from "vuelidate";
import Vuesax from "vuesax";
import VueI18n from "vue-i18n";
import ScrollLoader from "vue-scroll-loader";
import VueHtml2Canvas from "vue-html2canvas";
import { store } from "./store";
import { AxiosInterceptors } from "@/helpers/interceptors/axios.interceptors";
import { i18n } from "@/resources/locales";
import VueApexCharts from "vue-apexcharts";
import Vuex from "vuex";
import moment from "moment";
import VueMixpanelBrowser, {
  MixpanelPluginOptions,
} from "vue-mixpanel-browser";
import "vuesax/dist/vuesax.css";
import "./assets/theme/index.scss";
import "@fortawesome/fontawesome-free/css/all.css";
import VueShowdown from 'vue-showdown'
import VCalendar from 'v-calendar';
const options: MixpanelPluginOptions = {
  token: process.env.VUE_APP_MIXPANEL_PROJECT_TOKEN,
  config: { debug: false },
};
declare module "vue/types/vue" {
  interface Vue {
    $vs: any;
    $html2canvas: any;
  }
}
Vue.use(VueShowdown, {
  flavor: 'original',
  options: {
    emoji: true,
  },
});
Vue.use(VCalendar, {
  componentPrefix: 'vc',
});
Vue.prototype.moment = moment;
Vue.use(VueHtml2Canvas);
Vue.use(ScrollLoader);
Vue.use(Vuex);
Vue.use(Vuelidate);
Vue.use(VueI18n);
Vue.use(VueApexCharts);
Vue.use(VueMixpanelBrowser, options);
Vue.component("apexchart", VueApexCharts);
Vue.use(Vuesax, {
  colors: {
    primary: "#2b3d8e",
  },
});
new AxiosInterceptors();
new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
